class QuizElement extends HTMLElement {
  constructor() {
    super(),
      (this.resultsPageHandle = "quiz-results"),
      (this.sections = this.querySelectorAll(".element-section")),
      (this.currentIndex = 0),
      (this.totalSteps = this.sections.length - 1),
      (this.quizIndex = this.dataset.quiz),
      (this.header = this.querySelector(".element-header")),
      (this.progressBar = this.querySelector(".element-headerProgress div")),
      (this.loadingOverlay = this.querySelector(".element-loading")),
      (this.backButton = this.querySelector(".element-headerButton button")),
      (this.cartButton = this.querySelector(".element-cart")),
      (this.stepsWrapper = this.querySelector(".element-headerSteps > span")),
      (this.currentStepSpan = this.querySelector("[data-current]")),
      (this.category = localStorage.getItem("selectedQuizId") || ""),
      (this.responses =
        JSON.parse(localStorage.getItem("quizResponses")) || {}),
      (this.responsesFull =
        JSON.parse(localStorage.getItem("quizResponsesFull")) || {}),
      (this.emailSectionIndex = parseInt(
        document.querySelector(".section-email").dataset.index,
      )),
      (this.cache = {});
  }
  connectedCallback() {
    this.initializeQuiz(),
      this.savedQuiz("load"),
      this.klaviyoForm(),
      window.addEventListener("hashchange", () => this.loadFromHash()),
      this.delegateListener("change", "#checkobx-subs", (e) => {
        document
          .querySelectorAll('[data-section="quiz_products"] .grid-item')
          .forEach((e) => {
            let t = e.querySelector(".discounted"),
              s = e.querySelector(".default"),
              n = e.querySelector(".element-badge");
            t.classList.toggle("hide"),
              s.classList.toggle("hide"),
              n.classList.toggle("hide");
          }),
          document.querySelectorAll(".sub-element").forEach((e) => {
            e.classList.toggle("hide");
          });
      }),
      this.delegateListener("click", ".section-results [data-id]", (e) =>
        this.productCartButton(e),
      ),
      this.delegateListener("click", ".variant-option", async (e) => {
        const t = e.target.closest(".variant-option"),
          s = t.closest(".grid-item"),
          n = t.closest(".grid-item").querySelector("[data-id]");
        if (!t) return;
        const o = t.closest("ul"),
          i =
            ([...o.parentElement.querySelectorAll("ul")].indexOf(o),
            t.closest(".element-variants")),
          r = JSON.parse(i.querySelector("[data-json]").textContent);
        o
          .querySelectorAll(".variant-option")
          .forEach((e) => e.classList.remove("style--selected")),
          t.classList.add("style--selected");
        const l = [...i.querySelectorAll("ul")].map((e) => {
            const t = e.querySelector(".style--selected");
            return t ? t.dataset.value : null;
          }),
          a = r.find((e) => e.options.every((e, t) => e === l[t]));
        n.dataset.id = a ? a.id : "";
        const c = `/products/${t.dataset.handle}?variant=${a.id}&view=quiz_card`,
          u = s.querySelector(".element-group");
        if (this.cache[c]) u.innerHTML = this.cache[c];
        else
          try {
            const e = await fetch(c);
            if (!e.ok) throw new Error("Network response was not ok");
            const t = await e.text();
            (this.cache[c] = t), (u.innerHTML = t);
          } catch (e) {
            console.error("Variant fetch failed:", e);
          }
      });
  }
  initializeQuiz(e = 0) {
    const t = (e, t, s) => {
        e.forEach((e) => {
          (e.dataset.hide = t ? "true" : "false"),
            e.querySelectorAll("input, select").forEach((e) => {
              e.disabled = s;
            });
        });
      },
      s = (e) => {
        const s = this.querySelectorAll(".options-primary"),
          n = this.querySelectorAll(".options-secondary"),
          o = 2 == e;
        t(s, !o, !o), t(n, o, o);
      };
    s(this.responses.option_3),
      this.delegateListener("change", '[name="option_3"]', (e) => {
        s(e.target.value);
      }),
      this.loadFromHash(e, !0),
      this.populateInputs(),
      this.updateProgress(),
      this.addNavigation(),
      this.weightInputSetup();
  }
  loadFromHash(e, t = !1) {
    let s = window.location.pathname.match(/^\/pages\/[^/]+\/([^#/]+)/),
      n = s ? s[1] : "",
      o = parseInt(window.location.hash.replace("#step-", ""), 10) || e;
    if (
      (console.log(window.location.pathname, s, n),
      n && !n.includes("=") && (o = this.totalSteps),
      n && (o = this.totalSteps),
      (isNaN(o) || o < 0 || o > this.totalSteps) && (o = 0),
      this.toggleSection(this.currentIndex, o),
      (this.currentIndex = o),
      this.updateProgress(),
      this.emailSectionIndex - 1 === this.currentIndex &&
        this.populateFormInputs(document.querySelector(".section-email")),
      this.currentIndex === this.totalSteps)
    ) {
      if (!t) return;
      this.fetchResultsPage();
    }
  }
  collectResponses(e) {
    const t = this.sections[e].querySelectorAll("[name]:not([disabled])"),
      s = {};
    t.forEach((e) => {
      const t = e.name,
        n = e.closest(".element-section")?.querySelector("h2.heading"),
        o = n?.dataset.name?.trim() || n?.textContent.trim();
      let i = e.nextElementSibling?.textContent?.trim() || e.value;
      const r = e.closest(".section-email");
      e.nextElementSibling?.querySelector(".element-value") &&
        (i = e.nextElementSibling
          ?.querySelector(".element-value")
          ?.textContent?.trim()),
        "checkbox" === e.type
          ? ((this.responses[t] && Array.isArray(this.responses[t])) ||
              (this.responses[t] = []),
            e.checked
              ? this.responses[t].includes(e.value) ||
                this.responses[t].push(e.value)
              : (this.responses[t] = this.responses[t].filter(
                  (t) => t !== e.value,
                )),
            0 === this.responses[t].length && delete this.responses[t])
          : "text" === e.type || "number" === e.type
            ? ((this.responses[t] = e.value),
              0 === this.responses[t].length && delete this.responses[t])
            : ("radio" === e.type && e.checked) || "select-one" === e.type
              ? (this.responses[t] = e.value)
              : "hidden" === e.type &&
                (this.responses[t] = e.value.replace(".", "_")),
        o &&
          !r &&
          ("checkbox" === e.type
            ? (s[o] || (s[o] = []),
              e.checked && s[o].push(i.replaceAll(".", "")))
            : "radio" === e.type && e.checked
              ? (this.responsesFull[o] = i.replaceAll(".", ""))
              : "text" === e.type
                ? (this.responsesFull[o] = e.value.replaceAll(".", ""))
                : "number" === e.type
                  ? (this.responsesFull[o] =
                      e.value.replaceAll(".", "") +
                      e.getAttribute("placeholder"))
                  : "select-one" === e.type
                    ? (this.responsesFull[o] = e.value.replaceAll(".", ""))
                    : "hidden" === e.type &&
                      (this.responsesFull[t] = e.value.replace(".", "_")));
    }),
      Object.entries(s).forEach(([e, t]) => {
        t.length > 0
          ? (this.responsesFull[e] = t.join("; ").replaceAll(".", ""))
          : delete this.responsesFull[e];
      }),
      localStorage.setItem("quizResponses", JSON.stringify(this.responses)),
      localStorage.setItem(
        "quizResponsesFull",
        JSON.stringify(this.responsesFull),
      );
  }
  populateInputs() {
    Object.keys(this.responses).forEach((e) => {
      this.querySelectorAll(`[name='${e}']:not([disabled])`).forEach((t, s) => {
        if ("radio" === t.type) t.checked = this.responses[e] === t.value;
        else if ("checkbox" === t.type) {
          let s = this.responses[e] || [];
          t.checked = s.includes(t.value);
        } else
          "select-one" === t.type
            ? (console.log(t, `option[value='${this.responses[e]}']`),
              t.querySelector(`option[value='${this.responses[e]}']`)
                ? (t.querySelector(
                    `option[value='${this.responses[e]}']`,
                  ).selected = !0)
                : delete this.responses[e])
            : "text" === t.type && (t.value = this.responses[e]);
      });
    });
  }
  getParamsFromUrl() {
    let e = window.location.pathname.match(/^\/pages\/[^/]+\/([^#/]+)/),
      t = e ? e[1] : "",
      s = new URLSearchParams(t),
      n = {};
    for (let [e, t] of s.entries())
      t.includes("+") ? (n[e] = t.split("+")) : (n[e] = t);
    return n;
  }
  toggleSection(e, t) {
    if (
      (console.log(this.sections[t].classList),
      this.sections[t].classList.contains("section-email") ||
        this.sections[t].classList.contains("section-results"))
    ) {
      this.responsesFull;
      let e = new URLSearchParams();
      Object.keys(this.responses).forEach((t) => {
        let s = this.responses[t];
        e.append(t, Array.isArray(s) ? s.join("+") : s);
      }),
        (e = e.toString()),
        this.setFormInputValues(),
        this.sections[t].innerText.includes("Thanks for subscribing!") &&
          location.reload();
    }
    this.sections[e] && (this.sections[e].dataset.active = "false"),
      this.sections[t] && (this.sections[t].dataset.active = "true");
  }
  updateProgress() {
    let e = ((this.currentIndex + 1 - 1) / (this.totalSteps + 1 - 1)) * 100;
    (this.progressBar.style.width = `${e}%`),
      (this.currentStepSpan.innerHTML = `${this.currentIndex + 1}/${this.totalSteps}`),
      this.currentStepSpan.classList.remove("hide"),
      this.backButton.classList.remove("hide"),
      this.backButton.nextElementSibling.classList.add("hide"),
      this.cartButton.classList.add("hide"),
      this.header.classList.remove("style--results"),
      this.currentIndex === this.totalSteps &&
        (this.backButton.classList.add("hide"),
        this.cartButton.classList.remove("hide"),
        this.backButton.nextElementSibling.classList.remove("hide"),
        this.header.classList.add("style--results"),
        (this.currentStepSpan.innerHTML = `<button id="product-section" type="button" class="button--primary">${JSON.parse(this.dataset.strings).products}</button>`)),
      0 == this.currentIndex &&
        (this.backButton.classList.add("hide"),
        this.currentStepSpan.classList.add("hide")),
      this.updateName();
  }
  addNavigation() {
    const e = this.querySelector("[data-button='back']");
    e && e.addEventListener("click", () => this.prevSection()),
      this.sections.forEach((e, t) => {
        if (
          e.classList.contains("section-results") ||
          e.classList.contains("section-dashboards")
        )
          return;
        if (e.querySelector('[data-type="Single Option"]'))
          return void e
            .querySelectorAll('[data-type="Single Option"] input')
            .forEach((e) => {
              e.addEventListener("click", (e) => {
                this.nextSection(t);
              });
            });
        let s = e.querySelector(".next-button");
        s
          ? s.addEventListener("click", () => this.nextSection(t))
          : ((s = document.createElement("button")),
            s.classList.add("next-button", "button--primary"),
            (s.textContent = JSON.parse(this.dataset.strings).next),
            s.addEventListener("click", () => this.nextSection(t)),
            e.querySelector(".section--inner .element-button").appendChild(s));
      }),
      this.delegateListener(
        "click",
        '[data-section="quiz_hero"] button',
        () => {
          this.querySelector('[data-section="quiz_blocks"]').scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        },
      ),
      this.delegateListener("click", "#product-section", () => {
        const e = this.querySelector('[data-section="quiz_info2"]'),
          t = this.querySelector('[data-section="quiz-element"] > header'),
          s = t ? t.offsetHeight : 0,
          n = e.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: n - s, behavior: "smooth" });
      }),
      this.delegateListener("click", ".element-cart", () => {
        document.querySelector("#cart-icon-bubble").click();
      });
  }
  populateFormInputs(e) {
    const t = JSON.parse(localStorage.getItem("quizResponses")) || {},
      s = e.querySelectorAll("input[type='email']");
    console.log(t),
      s.forEach((e) => {
        const s = e.placeholder.replaceAll(" ", "_").toLowerCase();
        if (t[s]) {
          e.value = t[s];
          const n = new Event("input", { bubbles: !0 });
          e.dispatchEvent(n);
        }
      });
  }
  updateName(e) {
    this.responses.option_2 &&
      this.querySelectorAll("p, .heading, .element-value").forEach((t) => {
        1 === t.childNodes.length &&
          t.childNodes[0].nodeType === Node.TEXT_NODE &&
          ((t.textContent = t.textContent.replace(
            /{\w+}/g,
            this.responses.option_2,
          )),
          e &&
            (t.textContent = t.textContent.replace(
              e,
              this.responses.option_2,
            )));
      });
  }
  nextSection(e) {
    let t = this.responses.option_2;
    if ((this.collectResponses(e), 1 == this.currentIndex)) {
      const e = document.querySelector('input[name="option_2"]');
      if (!e.value.trim())
        return (
          (e.style.borderColor = "#ff5050"),
          void setTimeout(() => {
            e.style.borderColor = "";
          }, 600)
        );
      this.updateName(t);
    }
    console.log(
      "nextSection",
      e,
      this.currentIndex,
      this.totalSteps - 1,
      this.currentIndex === this.totalSteps - 1,
    ),
      this.currentIndex < this.totalSteps - 1
        ? (console.log("nextSection 1"), this.updateHash(this.currentIndex + 1))
        : this.currentIndex === this.totalSteps - 1 &&
          (console.log("nextSection 2"),
          this.fetchResultsPage(() => this.updateHash(this.currentIndex + 1)));
  }
  prevSection() {
    this.currentIndex > 0
      ? this.updateHash(this.currentIndex - 1)
      : window.location.replace(window.location.origin);
  }
  updateHash(e) {
    window.location.hash = `#step-${e}`;
  }
  weightInputSetup() {
    const e = this.querySelector("[data-weight]")?.closest(".element-section");
    if (!e) return;
    const t = e.querySelector(".next-button"),
      s = e.querySelector("[data-weight]"),
      n = e.querySelector(".input--group");
    t.disabled = !0;
    const o = document.createElement("div");
    Object.assign(o.style, {
      color: "red",
      fontSize: "14px",
      marginTop: "5px",
    }),
      n.appendChild(o);
    const i = (e) => (o.textContent = e);
    if (
      (Object.assign(s, { placeholder: "KG" }),
      (n.dataset.units = "KG"),
      this.responses[`option_${e.dataset.index}`])
    ) {
      const t = this.responses[`option_${e.dataset.index}`];
      Object.assign(s, { value: t });
    }
    const r = () => {
      const e = s.value.trim();
      if (((t.disabled = !0), !e)) return i("Laukas yra privalomas.");
      const n = this.validateWeight(null, e, !0);
      if (n)
        return (
          i(n),
          void (n.includes("Weight") && (s.style.border = "1px solid red"))
        );
      (o.textContent = ""), (s.style.border = ""), (t.disabled = !1);
    };
    s.addEventListener("input", r), r();
  }
  validateWeight(e, t, s) {
    if (!t) return "Weight must be filled.";
    if (s) {
      if (!/^\d+(\.\d+)?$/.test(t)) return "Weight must be a number.";
      const e = parseFloat(t);
      if (e < 1 || e > 80) return "Weight must be between 1 and 80 kg.";
    }
    return null;
  }
  savedQuiz(e, t, s) {
    if ("save" === e) {
      const e = JSON.parse(localStorage.getItem("savedQuiz")) || {};
      console.log("savedQuiz", t),
        t ? (e[t] = s) : (e.Augintinis = s),
        localStorage.setItem("savedQuiz", JSON.stringify(e));
    } else {
      const e = document.getElementById("savedQuiz"),
        t = JSON.parse(localStorage.getItem("savedQuiz")) || {};
      for (const s in t) {
        const n = t[s];
        e.classList.remove("hide");
        const o = document.createElement("li");
        o.classList.add("button", "button--primary");
        const i = document.createElement("a");
        (i.href = n), (i.textContent = s);
        const r = document.createElement("button");
        (r.textContent = ""),
          (r.style.marginLeft = "5px"),
          (r.dataset.name = s),
          o.appendChild(i),
          o.appendChild(r),
          e.appendChild(o);
      }
    }
    this.delegateListener("click", "#savedQuiz button", (e) => {
      const t = e.target,
        s = t.dataset.name;
      if (!s) return;
      const n = JSON.parse(localStorage.getItem("savedQuiz")) || {};
      delete n[s], localStorage.setItem("savedQuiz", JSON.stringify(n));
      const o = t.closest("li");
      o && o.remove();
    });
  }
  fetchResultsPage(e) {
    let t = new URLSearchParams(),
      s = this.getParamsFromUrl();
    this.backButton.dataset.hidden = 0 !== Object.keys(s).length;
    let n = JSON.parse(localStorage.getItem("quizResponsesFull")) || {};
    if (
      ((this.responsesFull = Object.keys(s).length > 0 ? s : n),
      this.responsesFull.quiz != this.quizIndex)
    )
      return (
        localStorage.removeItem("quizResponses"),
        localStorage.removeItem("quizResponsesFull"),
        void window.location.replace(
          location.href.match(/^https?:\/\/[^\/]+\/[^\/]+\/[^\/]+/)[0],
        )
      );
    Object.keys(this.responsesFull).forEach((e) => {
      let s = this.responsesFull[e]
        .replaceAll("+", "plu5s")
        .replaceAll("/", "sla5sh");
      t.append(e, Array.isArray(s) ? s.join("+") : s);
    }),
      (document.body.style.overflow = "hidden"),
      this.loadingOverlay.classList.remove("hide"),
      this.savedQuiz(
        "save",
        this.responses.option_2,
        `${location.origin + window.Shopify.routes.root}pages/quiz/${t.toString()}`,
      ),
      fetch(
        `${location.origin + window.Shopify.routes.root}pages/${this.resultsPageHandle}/${t.toString()}`,
      )
        .then((e) => e.text())
        .then((t) => {
          let s = this.querySelector("[data-results]");
          s &&
            (s.innerHTML = new DOMParser()
              .parseFromString(t, "text/html")
              .querySelector("#MainContent").innerHTML),
            e && e(),
            setTimeout(() => {
              this.loadingOverlay.classList.add("hide"),
                (document.body.style.overflow = "visible"),
                document.querySelectorAll("#section--2 p").forEach((e) => {
                  "&nbsp;" === e.innerHTML.trim() && e.remove();
                });
            }, 2500);
        })
        .catch((e) => console.error("Error fetching results:", e));
  }
  setFormInputValues() {
    let e = this.responsesFull;
    const t = setInterval(() => {
      const s = document.querySelector('.section-email [id^="omnisend-form-"]'),
        n = s ? s.querySelector("form") : null;
      if (!n) return;
      let o = 0;
      Object.entries(e).forEach(([e, t]) => {
        const s = n.querySelector(
          `[name="custom_${((i = e), i.replaceAll("ą", "a").replaceAll("Ą", "A").replaceAll("č", "c").replaceAll("Č", "C").replaceAll("ę", "e").replaceAll("Ę", "E").replaceAll("ė", "e").replaceAll("Ė", "E").replaceAll("į", "i").replaceAll("Į", "I").replaceAll("š", "s").replaceAll("Š", "S").replaceAll("ų", "u").replaceAll("Ų", "U").replaceAll("ū", "u").replaceAll("Ū", "U").replaceAll("ž", "z").replaceAll("Ž", "Z").replaceAll(" ", "_"))}"]`,
        );
        var i;
        s
          ? ((s.value = t),
            s.dispatchEvent(new Event("input", { bubbles: !0 })),
            o++)
          : console.warn(`⚠️ Input with aria-label "${e}" not found`);
      }),
        o > 0 &&
          console.log(`✅ ${o} quiz answers injected into Omnisend form.`),
        clearInterval(t);
    }, 300);
  }
  klaviyoForm() {
    const e = document.querySelector(
        '.section-email [id^="omnisend-embedded-"]',
      ),
      t = document.querySelector(".section-email .element-button .next-button");
    if (e && t) {
      t.style.display = "none";
      let s = !1;
      new MutationObserver((n, o) => {
        if (!s)
          for (const i of n)
            if ("attributes" === i.type && "style" === i.attributeName) {
              const n = e.querySelector(
                  '[class*="success-sections-container"]:not([style*="display: none"])',
                ),
                i = e.querySelector(
                  '[class*="subscribed-sections-container"]:not([style*="display: none"])',
                );
              if (n || i) {
                (s = !0),
                  (t.style.display = "block"),
                  this.nextSection(e.closest(".section-email").dataset.index),
                  o.disconnect();
                break;
              }
            }
      }).observe(e, {
        attributes: !0,
        childList: !0,
        subtree: !0,
        attributeFilter: ["style"],
      });
    }
  }
  cartAdd(e, t) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(e),
    })
      .then((e) => e.json())
      .then((e) => {
        fetch(window.Shopify.routes.root + "?sections=cart-icon-bubble")
          .then((e) => e.json())
          .then((e) => {
            (document.querySelector("#cart-icon-bubble2").innerHTML =
              new DOMParser()
                .parseFromString(e["cart-icon-bubble"], "text/html")
                .querySelector("#shopify-section-cart-icon-bubble").innerHTML),
              document
                .querySelector(".element-headerSteps .cart-count-bubble")
                .classList.remove("hide"),
              t.classList.remove("button--loading");
          });
      })
      .catch((e) => {
        console.error("Error:", e);
      });
  }
  productCartButton(e) {
    let t = e.target,
      s = t.dataset.id,
      n = (t.dataset.plan, t.dataset.price, { id: s, quantity: 1 }),
      o = { items: [], sections: "cart-data" };
    o.items.push(n), t.classList.add("button--loading"), this.cartAdd(o, t);
  }
  cartAdd(e, t) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(e),
    })
      .then((e) => e.json())
      .then((e) =>
        fetch(`${window.Shopify.routes.root}?sections=cart-icon-bubble`),
      )
      .then((e) => e.json())
      .then((e) => {
        (document.querySelector(".cart-count-bubble").innerHTML =
          new DOMParser()
            .parseFromString(e["cart-icon-bubble"], "text/html")
            .querySelector(".cart-count-bubble").innerHTML),
          console.log(e),
          document
            .querySelector(".element-headerSteps .cart-count-bubble")
            .classList.remove("hide"),
          t.classList.remove("style--buttonLoading");
      })
      .catch(console.error);
  }
  productCartButton0(e) {
    let t = e.target,
      s = t.closest(".element-products"),
      n = document.querySelector(
        '[data-section="quiz_products"] #checkobx-subs',
      )?.checked,
      { id: o, plan: i, price: r, subscriptionPrice: l, qty: a } = t.dataset,
      c = { id: o, quantity: parseInt(a) },
      u = { items: [] };
    if (i && !n) {
      (r = l), (c.selling_plan = i);
      let { cartMessage: e, checkoutMessage: t } = s.dataset;
      (e || t) &&
        ((c.properties = {}),
        e && (c.properties[window.theme.cart_message] = e),
        t && (c.properties[window.theme.checkout_message] = t));
    }
    u.items.push(c),
      t.classList.add("style--buttonLoading"),
      this.cartAdd(u, t);
  }
}
customElements.define("quiz-element", QuizElement);
